import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguagesService } from 'src/app/services/languages.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {

  error = {
		esito: '',
		httpError: '',
		messaggio: '',
	};

	errorList:Map<string, string> = new Map<string, string>();

	constructor(private activeRoute: ActivatedRoute,
				private langService: LanguagesService) {
		this.error.esito = this.activeRoute.snapshot.paramMap.get('type');

		this.langService.getErrors("ENG").subscribe(data => {

			for(let i = 0; i < data.errori.length; i++) {
				this.errorList.set(data.errori[i].codiceErrore, data.errori[i].testo);
			}

			if (this.error.esito == '404') {
				this.error.httpError = '404';
				this.error.messaggio = 'not_found'
			} else {
				this.error.httpError = '401';
				this.error.messaggio = this.errorList.get(this.error.esito);
				if(this.error.messaggio == "" || this.error.messaggio == null){
					this.error.messaggio = "Generic error";
				}
			}
		},
    error=>{
      this.error.httpError = 'Generic error';
    });
	}

	ngOnInit() {
	}

}
